import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../types';
import { useTranslation } from '../i18n';

const PROVIDER_LABEL_KEYS: Record<string, string> = {
  mojeid: 'social.continue_mojeid',
  google: 'social.continue_google',
  facebook: 'social.continue_facebook',
};

export const SocialLoginButtons: React.FC = () => {
  const { t } = useTranslation();
  const [providers, setProviders] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get<{ providers: string[] }>(`${API_URL}/auth/external/providers`);
        if (!cancelled) {
          setProviders(res.data.providers ?? []);
        }
      } catch {
        if (!cancelled) {
          setProviders([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const startLogin = (provider: string) => {
    window.location.href = `${API_URL}/auth/external/${provider}/start`;
  };

  if (loading || providers.length === 0) {
    return null;
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '0.25rem 0' }}>
        <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #d1d5db' }} />
        <span style={{ color: '#6b7280', fontSize: '0.85rem' }}>{t('social.or_divider')}</span>
        <hr style={{ flex: 1, border: 'none', borderTop: '1px solid #d1d5db' }} />
      </div>
      {providers.map(provider => (
        <button
          key={provider}
          type="button"
          className="btn btn-secondary"
          style={{ width: '100%' }}
          onClick={() => startLogin(provider)}
        >
          {t(PROVIDER_LABEL_KEYS[provider] ?? 'social.continue_provider', { provider })}
        </button>
      ))}
    </>
  );
};
